import { styled } from "@mui/system";
import { Box, Button } from "@mui/material";

export const WrapperDiv = styled(Box)(({ theme }) => ({
  position: "relative",
  background: "#fff",
  padding: "50px 0 30px",
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  "&:before": {
    content: `""`,
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "47%",
    background: "url(bg.svg) no-repeat top center",
    backgroundSize: "100% 100%",
    zIndex: 0,
  },
  [theme.breakpoints.down("sm")]: {
    padding: "30px 20px",
  },
}));

export const HeaderDiv = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 1,
  padding: "15px 24px",
  textAlign: "center",
  "& > img": {
    height: "50px",
  },
}));

export const LoginBoxOuter = styled(Box)(({ theme }) => ({
  margin: "auto 0",
  padding: "30px 0",
  [theme.breakpoints.down("sm")]: {
    margin: "0 0 auto",
    padding: "70px 0 40px",
  },
}));

export const LoginBox = styled(Box)(({ theme }) => ({
  position: "relative",
  zIndex: 1,
  padding: "47px 42px",
  minWidth: "484px",
  maxWidth: "484px",
  margin: "0 auto",
  borderRadius: "15px",
  background: "#fff",
  boxShadow: "0 0 20px #00000030",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "30px 20px 24px",
    minWidth: "auto",
    maxWidth: "410px",
  },
}));

export const WelcomeTitle = styled(Box)(({ theme }) => ({
  fontSize: "42px",
  fontWeight: 600,
  lineHeight: "37px",
  letterSpacing: ".2px",
  color: "#51545f",
  marginBottom: "10px",
}));

export const WelcomeDesc = styled(Box)(({ theme }) => ({
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: "32px",
  letterSpacing: ".2px",
  color: "#8d92a2",
}));

export const SignInButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  borderColor: "#2F2F2F",
  color: "#2F2F2F",
  backgroundColor: "#ffffff",
  "&:hover": {
    backgroundColor: "#f3f3f3",
    borderColor: "#2F2F2F",
  },
  "&:disabled": {
    border: "1px solid rgba(0, 0, 0, 0.12)",
    color: "rgba(0, 0, 0, 0.26)"
  },
}));

export const LoginFooter = styled(Box)(({ theme }) => ({
  marginTop: "auto",
  paddingBottom: "10px",
  textAlign: "center",

  [theme.breakpoints.down("sm")]: {
  paddingBottom: "0px",
  },

  "& > p": {
    color: "#6a6a6a",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "18px",
    letterSpacing: ".7px",
  },
}));
